import React from "react";
import { cn } from "lib/utils";

export const RedHighlight = ({
  children,
  className,
}: {
  children: React.ReactNode;
  className?: string;
}) => {
  return (
    <span
      className={cn(
        "font-bold bg-red-700/[0.2] text-red-500 px-1 py-0.5",
        className
      )}
    >
      {children}
    </span>
  );
};
